<div *ngIf="mapLoader.mapsLoaded | async">
  <google-map [zoom]="14"
              [center]="location"
              width="100%"
              aria-label="Map showing reported Location">
    <map-marker [position]="location"></map-marker>
  </google-map>
  <p *ngIf="showCoords">{{'location-view.latitude' | translate}} {{ location.lat | number:'1.5' }} {{'location-view.longitude' | translate}} {{ location.lng | number:'1.5' }}</p>
</div>
